<script setup>
import {computed, useSlots} from 'vue';
import SectionTitle from './SectionTitle.vue';

// Define props to accept "noGrid"
const props = defineProps({
  noGrid: {
    type: Boolean,
    default: false, // Default is false (grid enabled)
  },
  gridClasses: {
    type: String,
    required: false
  }
});

defineEmits(['submitted']);

const hasActions = computed(() => !!useSlots().actions);
</script>

<template>
  <div class="md:grid md:grid-cols-3 md:gap-6">
    <SectionTitle>
      <template #title>
        <slot name="title"/>
      </template>
      <template #description>
        <slot name="description"/>
      </template>
    </SectionTitle>

    <div class="mt-5 md:mt-0 md:col-span-2">
      <form @submit.prevent="$emit('submitted')">
        <div
          class="px-4 py-5 bg-white sm:p-6 shadow"
          :class="hasActions ? 'sm:rounded-tl-md sm:rounded-tr-md' : 'sm:rounded-md'"
        >
          <div :class="props.noGrid ? ['grid', gridClasses] : 'grid grid-cols-6 gap-6'"> <!-- Conditional grid class -->
            <slot name="form" />
          </div>
        </div>

        <div v-if="hasActions"
             class="flex items-center justify-end px-4 py-3 bg-gray-50 text-right sm:px-6 shadow sm:rounded-bl-md sm:rounded-br-md">
          <slot name="actions"/>
        </div>
      </form>
    </div>
  </div>
</template>
